export enum AverLanguage {
  ENGLISH = "EN",
  SPANISH = "ES",
  CHINESE = "CN",
}

export const defaultLanguage = AverLanguage.ENGLISH;
